import { Flex, ShareAltIcon, Text } from "@fluentui/react-northstar";
import { SurveyDTO } from "@teams/types/api";
import React from "react";

import { PollyDialog } from "./PollyDialog";
import { SurveyExternalLink } from "./SurveyExternalLink";

type Props = {
  survey: SurveyDTO;
  open?: boolean;
  width?: string | number | undefined;
  maxWidth?: string;
  onCancel: () => void;
};

export const ShareSurveyDialog: React.FC<Props> = ({ open, width, maxWidth, survey, onCancel }) => {
  return (
    <PollyDialog
      open={open}
      width={width}
      maxWidth={maxWidth}
      header={
        <Flex vAlign="center">
          <ShareAltIcon xSpacing="after" size="large" />
          Share
        </Flex>
      }
      onCancel={onCancel}
    >
      <Flex column gap="gap.small" hAlign="stretch" style={{ marginTop: "0.5rem" }}>
        <Text
          align="center"
          weight="bold"
          content={
            !survey.shortCodeUri
              ? "Create a dedicated link to send this polly to anyone in your company?"
              : "Dedicated link for sending this polly to your company!"
          }
        />
        <SurveyExternalLink primary survey={survey} trackingMethod="share-dialog" />
      </Flex>
    </PollyDialog>
  );
};
